import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Container, Modal, Row, Table, Image, Popover, OverlayTrigger } from 'react-bootstrap';
import { Info, Plus, Minus, Mail } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import NotyfContext from '../../contexts/NotyfContext';
import { fetchCurrentProgress } from '../../redux/slices/DashboardSlice';
import { blankGetAllReportData, getAllReport } from '../../redux/slices/ReportSlice';
import Experian from '../../assets/img/brands/experian.svg';
import Equifax from '../../assets/img/brands/equifax.svg';
import TransUnion from '../../assets/img/brands/transunion.svg';
import Background from './bg-credit-audit.svg';
import { getScoreText, getScoreColor } from '../../constants';
import { ArrowDown, ArrowRight, ArrowUp, Check, Triangle } from 'react-feather';
import Path from './path-credit-audit.png';
import finishLineShapes from './finish-line-shapes.png';
import styled, { keyframes } from 'styled-components';
import CreditBuilder from '../creditbuilder/CreditBuilder';
import CurrentProcess from '../../components/charts/CurrentProcess';
import { fetchDerogatoryReport } from '../../redux/slices/CreditAuditSlice';
import CreditSummary from './CreditSummaryAudit';
import Bear from '../dasboard/summary-bear.svg';
import Bull from '../dasboard/summary-bull.svg';
import Clock from '../dasboard/summary-clock.svg';
import Dollar from '../dasboard/summary-dollar.svg';
import Installment from '../dasboard/summary-installment.svg';
import Pages from '../dasboard/summary-pages.svg';
import StarIcon from '../dasboard/summary-star.svg';
import { PlusCircle, XCircle, CheckCircle, Star, Circle, MinusCircle } from 'react-feather';
import moment from 'moment';
import ExpenseChart from './ExpenseChart';
import { current } from '@reduxjs/toolkit';
import infoPopover from '../../components/new/Popover';
import MobilePath from './mobile-path.png';
import Step0 from './Step0.png';
import Step1 from './Step1.png';
import Step2 from './Step2.png';
import Step3 from './Step3.png';
import Step4 from './Step4.png';
import Step5 from './Step5.png';
import Step6 from './Step6.png';
import Bot0 from './0.png';
import Bot1 from './1.png';
import Bot2 from './2.png';
import Bot3 from './3.png';
import Bot4 from './4.png';
import Bot5 from './5.png';
import Joyride from 'react-joyride';
import { fetchTourProgresses, updateTourProgress } from '../../redux/slices/TourProgressSlice';
import Bolt from '../dispute_center/partials/lightning-bolt.svg';
import standardStar from '../dispute_center/partials/standard-star.svg';
import { callUserActvity } from '../../redux/slices/CommonSlice';
import GoldStar from '../../pages/dispute_center/partials/star.svg';
import BotAtlas from './bot-atlas.png';

const pulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.3;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
`;

const CreditAudit = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: <>Start here!</>,
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: (
        <>
          <p>Click "Learn More" to... well... learn more!</p>
          <p>Find out everything you could possibly want to know about each part of your credit</p>
        </>
      ),
    },
    {
      target: '.third-step',
      content: (
        <>
          <p>Click on the number for each section to get details customized for you!</p>
        </>
      ),
    },
  ];
  // Tour Progresses
  const tourStatus = useSelector(state => state.tourProgress.status);
  const tours = useSelector(state => state.tourProgress.tours);

  useEffect(() => {
    if (tourStatus === 'idle') dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    if (tours.filter(tour => tour.tour_name === 'credit-audit' && tour.completed).length === 0) setRun(true);
    else if (['loading', 'idle'].includes(tourStatus)) setRun(false);
    else setRun(false);
  }, [tours, tourStatus]);

  const handleJoyrideCallback = data => {
    const { type, status, index, action } = data;
    if (type === 'tour:end') dispatch(updateTourProgress({ tour_name: 'credit-audit', completed: 1 }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentStep(1);
    }, 10);

    return () => clearTimeout(timer);
  }, []);
  const [showStepModal, setShowStepModal] = useState({});

  const handleStepModalClose = step => {
    setShowStepModal(prevState => ({ ...prevState, [step]: false }));
  };

  const handleStepModalShow = step => {
    handleSetCurrentStep(step);
    setShowStepModal(prevState => ({ ...prevState, [step]: true }));
  };

  const popoverHoverFocus = (
    <Popover id='popover-trigger-hover-focus' title='Popover bottom'>
      <strong>Holy guacamole!</strong> Check this info.
    </Popover>
  );

  const [step1Modal, setShowStep1Modal] = useState(false);
  const [step2Modal, setShowStep2Modal] = useState(false);
  const [step3Modal, setShowStep3Modal] = useState(false);
  const [step4Modal, setShowStep4Modal] = useState(false);
  const [step5Modal, setShowStep5Modal] = useState(false);
  const [step6Modal, setShowStep6Modal] = useState(false);
  const [historyYear, setHistoryYear] = useState(moment().year());
  const [rightValues, setRightValues] = useState({
    1: '0px',
    2: '130px',
    3: '-1090px',
    4: '240px',
    5: '-1220px',
    6: '-520px',
  });

  const handleSetCurrentStep = step => {
    setCurrentStep(step);

    if (step === currentStep) {
      setRightValues(prevRightValue => ({
        ...prevRightValue,
        [step]: rightValues[step],
      }));
    } else {
      setRightValues(rightValues[step]);
    }
  };

  const creditAuditBackground = {
    backgroundImage: `url(${Background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const calculateOwedChange = (data, cur_index) => {
    const current = data[cur_index];
    const previous = data[cur_index];
    const prevSum = previous.total_balance_installment + previous.total_balance_revolving;

    const difference = prevSum - (current.total_balance_installment + current.total_balance_revolving);
    return Math.floor((difference / prevSum) * 100);
  };

  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const reportStatus = useSelector(state => state.reports.getAllReportStatus);
  const getAllReportData = useSelector(state => state.reports.getAllReportData);
  const [showLoader, setShowLoader] = useState(false);
  const error = useSelector(state => state.reports.error);

  //credit audit DR Report
  const derogatoryReport = useSelector(state => state.creditAudit.derogatoryReport);
  const drError = useSelector(state => state.creditAudit.drError);
  const drStatus = useSelector(state => state.creditAudit.drStatus);

  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);

  let clientName = '';
  var creditSummary = {};
  let cpData = {};
  let score = {
    equifax: 0,
    experian: 0,
    transunion: 0,
    equifaxLabel: '',
    experianLabel: '',
    transunionLabel: '',
  };
  let potentialScore = {
    equifax: 0,
    experian: 0,
    transunion: 0,
    equifaxLabel: '',
    experianLabel: '',
    transunionLabel: '',
    equifaxPresentage: '',
    experianPresentage: '',
    transunionPresentage: '',
  };
  let total_derogatory_items = 0;
  let derogatory_items = [];
  let credit_utilizations = [];
  let verify_info_logs = {};
  let debt_owed_data = {};

  useEffect(() => {
    if (reportStatus === 'idle') {
      let obj = {
        clientId: 1,
        roundid: 1,
      };
      dispatch(getAllReport(obj));
    }
  }, [reportStatus, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(blankGetAllReportData());
    };
  }, []);

  useEffect(() => {
    if (drStatus === 'idle') {
      dispatch(fetchDerogatoryReport());
    }
  }, [drStatus]);

  const handleChartYearChange = year => {
    setHistoryYear(year);
    let obj = {
      clientId: 1,
      roundid: 1,
      round_year: year,
    };
    dispatch(getAllReport(obj));
  };

  const formatValue = value => {
    try {
      if (typeof value === 'string' && value.includes(',')) {
        return value.replace(',', '');
      }
    } catch (error) {
      console.error('Error in formatValue:', error);
    }
    return value;
  };


  if (reportStatus === 'loading' || showLoader || drStatus === 'loading') {
    return <Loader />;
  } else if (reportStatus === 'succeeded' || drStatus === 'succeeded') {
    if (getAllReportData && Object.keys(getAllReportData).length > 0) {
      if (getAllReportData.error == 0) {
        clientName = getAllReportData?.data?.client_name;
        let scoreOri = getAllReportData?.data?.scores;
        score.equifax = scoreOri.equifax;
        score.experian = scoreOri.experian;
        score.transunion = scoreOri.transunion;
        score.equifaxLabel = scoreOri.equifax_label;
        score.experianLabel = scoreOri.experian_label;
        score.transunionLabel = scoreOri.transunion_label;

        //potentialScore
        let potentialScoreOri = getAllReportData?.data?.potential_scores;
        potentialScore.equifax = potentialScoreOri.equifax;
        potentialScore.experian = potentialScoreOri.experian;
        potentialScore.transunion = potentialScoreOri.transunion;
        potentialScore.equifaxPresentage = potentialScoreOri.equifax_change_ratio;
        potentialScore.experianPresentage = potentialScoreOri.experian_change_ratio;
        potentialScore.transunionPresentage = potentialScoreOri.transunion_change_ratio;
        potentialScore.equifaxLabel = potentialScoreOri.equifax_label;
        potentialScore.experianLabel = potentialScoreOri.experian_label;
        potentialScore.transunionLabel = potentialScoreOri.transunion_label;
        creditSummary = getAllReportData.data.credit_summary;
        cpData = getAllReportData.data.graph_all_scores;
      }
    }

    if (derogatoryReport && Object.keys(derogatoryReport).length > 0) {
      if (derogatoryReport.error === 0) {
        total_derogatory_items = derogatoryReport.data.dispute_items.total_derogatory_items;
        derogatory_items = derogatoryReport.data.dispute_items.derogatory_items;
        credit_utilizations = derogatoryReport.data.credit_utilization;
        verify_info_logs = derogatoryReport.data.verify_info_logs;
        debt_owed_data.total_balance_installment = derogatoryReport.data.total_balance_installment;
        debt_owed_data.total_balance_revolving = derogatoryReport.data.total_balance_revolving;
        debt_owed_data.total_limit = derogatoryReport.data.total_limit;
        debt_owed_data.data = derogatoryReport.data.debt_owed;
      }
    }
  } else if (reportStatus === 'failed' || drStatus === 'failed') {
    let message = '';
    if (reportStatus === 'failed') {
      message = error;
    }
    if (drStatus === 'failed') {
      message = drError;
    }
    notyf.open({
      type: 'danger',
      message: message,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }

 
  const tableData = [
    {
      month: 'January',
      revolvingDebt: '$10,000',
      installmentDebt: '$5,000',
      totalLimits: '$50,000',
      accountDebtPercentage: '30%',
      accountDebtPercentageChange: '-',
    },
    {
      month: 'February',
      revolvingDebt: '$8,000',
      installmentDebt: '$6,000',
      totalLimits: '$60,000',
      accountDebtPercentage: '25%',
      accountDebtPercentageChange: '-17%',
    },
    {
      month: 'March',
      revolvingDebt: '$12,000',
      installmentDebt: '$4,000',
      totalLimits: '$55,000',
      accountDebtPercentage: '35%',
      accountDebtPercentageChange: '40%',
    },
    {
      month: 'April',
      revolvingDebt: '$9,000',
      installmentDebt: '$7,000',
      totalLimits: '$70,000',
      accountDebtPercentage: '20%',
      accountDebtPercentageChange: '-43%',
    },
    {
      month: 'May',
      revolvingDebt: '$11,000',
      installmentDebt: '$3,000',
      totalLimits: '$65,000',
      accountDebtPercentage: '28%',
      accountDebtPercentageChange: '40%',
    },
    {
      month: 'June',
      revolvingDebt: '$7,000',
      installmentDebt: '$9,000',
      totalLimits: '$80,000',
      accountDebtPercentage: '15%',
      accountDebtPercentageChange: '-46%',
    },
  ];

  // Calculate the monthly change for Account Debt %
  for (let i = 1; i < tableData.length; i++) {
    const prevValue = parseFloat(tableData[i - 1].accountDebtPercentage);
    const currValue = parseFloat(tableData[i].accountDebtPercentage);
    const change = ((currValue - prevValue) / prevValue) * 100;
    tableData[i].accountDebtPercentageChange = change.toFixed(2);
  }

  // Calculate Expense Budget
  function calculateDifference(expensesBudget, actualExpense) {
    return expensesBudget - actualExpense;
  }
  return (
    <React.Fragment>
      <Helmet title='Credit Audit' />
      <style>
        {`
#creditAuditContainer {
//    background-image: url(${Path});
//             background-repeat: no-repeat;
//       background-size: contain;
//       background-position:bottom;
// 
//         }

        .col-transition {
            transition: all 0.3s ease;
        }

        .StyledInfo {
          position: relative;
          width: 34px;
          height: 34px;
          z-index: 2;
        }

        .StyledInfo::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 2px solid #fff;
          opacity: 0;
          animation: pulse 3s linear infinite;
        }

        .StyledInfo:hover {
          cursor: pointer;
          opacity: 0.8; 
        }


        

        #robot-path {
          top: '350px'
        }

.icon {

    width: 20px;
    height: 20px;
    background-color: var(--bs-warning);
    border-radius: 50%;
}

@media (min-width: 992px) {
#bottom-space {
    height: 1170px;
  }
}

        
        @media (max-width: 768px) {
  .mobile-overflow-x-auto {
    overflow-x: auto !important;
  }
  #bottom-space {
    height: 0px;
  }
}

.wrapper {
  height:100vw;
}

.main {
  height:100vh;
}

/* Change the button background color */
.react-joyride__tooltip button {
  background-color: #0076FF !important; /* Change this to your desired color */
  border-color: #0076FF !important; /* Change this to your desired color */
}

/* Change the button hover background color */
.react-joyride__tooltip button:hover {
  background-color: #1b1848 !important; /* Change this to your desired hover color */
  border-color: #0076FF !important; /* Change this to your desired hover color */
}

/* Change the button properties */
.react-joyride__tooltip button[type="button"][data-action="back"] {
  appearance: none !important;
background-color: transparent !important;
border-style: none !important;
color: #0076FF !important;
cursor: pointer !important;
font-family: "Anek Bangla", sans-serif !important;
font-size: 16px !important;
font-weight: 400 !important;
line-height: 16px !important;
margin: 0 !important;
margin-right: auto !important;
padding: 8px !important;
text-align: center !important;
text-transform: none !important;
visibility: visible !important;


}

/* Change the button hover properties */
button[type="button"][data-action="back"]:hover {
 color: var(--bs-dark-blue) !important; 
  background-color: none !important; 
  
}

div[style*="align-items: center; display: flex; justify-content: flex-end; margin-top: 15px;"] > div {
  /* Override the style here */
  flex: inherit !important;
}


        `}
      </style>
      <Container fluid id='creditAuditContainer' className='p-0 container-fluid-1335'>
        <Joyride showSkipButton={true} locale={{ last: 'FINISH' }} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={false} hideCloseButton disableOverlayClose={true} disableCloseOnEsc={true} callback={handleJoyrideCallback} />
        <Row className='d-flex justify-content-center'>
          <Col xs='12' lg='8' className='rounded-4'>
            <Card className='rounded-4 p-4 border-0 shadow'>
              <Card.Header className='border-0 bg-white rounded-4 border-0'>
                <h2 className='h2 mt-3 mb-2'>Your credit improvement journey starts here!</h2>
                <p className='text-dark-blue mb-0 text-regular-16'>The path below is customized just for you, based on your credit profile, to help you reach the best highest score possible.</p>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col lg='4' className='mb-3 mb-lg-0'>
                    <Card className='border-0 rounded-3 shadow mb-0'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>Equifax</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {score.equifax || 0}
                          </div>
                        </div>
                        <div className='d-flex'>
                          <div>
                            <span
                              style={{
                                fontSize: '0px',
                                display: 'inline-flex',
                                margin: 'auto 1rem',
                              }}
                              className={`bg-${getScoreColor[score.equifaxLabel]} p-1 rounded-circle mx-auto me-2`}></span>
                          </div>
                          <div className='text-normal-16 fw-light'>{score.equifaxLabel}</div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg='4' className='mb-3 mb-lg-0'>
                    <Card className='border-0 rounded-3 shadow mb-0'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>Experian</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {score.experian || 0}
                          </div>
                        </div>
                        <div className='d-flex'>
                          <div>
                            <span
                              style={{
                                fontSize: '0px',
                                display: 'inline-flex',
                                margin: 'auto 1rem',
                              }}
                              className={`bg-${getScoreColor[score.experianLabel]} p-1 rounded-circle mx-auto me-2`}></span>
                          </div>
                          <div className='text-normal-16 fw-light'>{score.experianLabel}</div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg='4' className='mb-3 mb-lg-0'>
                    <Card className='border-0 rounded-3 shadow mb-0'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>TransUnion</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {score.transunion || 0}
                          </div>
                        </div>
                        <div className='d-flex'>
                          <div>
                            <span
                              style={{
                                fontSize: '0px',
                                display: 'inline-flex',
                                margin: 'auto 1rem',
                              }}
                              className={`bg-${getScoreColor[score.transunionLabel]} p-1 rounded-circle mx-auto me-2`}></span>
                          </div>
                          <div className='text-normal-16 fw-light'>{score.transunionLabel}</div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className='justify-content-center'>
          <Image id='robot-path' src={Path} alt='robot-path' fluid className='position-absolute d-lg-block d-none mx-auto' style={{ top: '350px;', width: '900px', zIndex: 9 }} />
          {/* <Image id='robot-path' src={MobilePath} alt='robot-path' fluid className='d-block d-lg-none mx-auto position-absolute' style={{ top: '950px' }} /> */}
        </Row>
        <Row>
          <Col xs={12}>
            <Image id='robot-path' src={Step0} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>
          {/* MOBILE */}
          <Col xs={currentStep === 1 ? 12 : 12} className='col-transition d-md-block d-lg-none'>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3'>Personal Information</h4>
                  <div className='sonar-wrapper'>
                    <Info
                      className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger'
                      width={34}
                      height={34}
                      strokeWidth={2}
                      onClick={() => {
                        setCurrentStep(1);
                        // handleSetCurrentStep(1);
                      }}
                    />
                    <div className='sonar-effect position-absolute'></div>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 1 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='mb-4'>Incorrect spelling of your name, different aliases, unknown addresses, and other personal information could be wrong on your reports. Credit Reporting agencies make errors like these all the time, and this incorrect information could have derogatory items attached to them that may not belong to you. It is important to make sure that all of the information reporting in this area of your reports is 100% accurate.</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at credit audit'));
                    setShowStep1Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            <Image id='robot-path' src={Step1} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>

          {/* NORMAL */}
          <Col lg={currentStep === 1 ? 4 : 2} className='col-transition position-absolute d-none d-lg-block first-step' style={{ zIndex: '90' }}>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3 d-flex align-items-center flex-row'>
                    <div
                      className='d-flex position-relative'
                      onClick={() => {
                        setCurrentStep(1);
                        // handleSetCurrentStep(1);
                      }}>
                      <span className='icon d-flex me-3 p-3 text-white' style={{ zIndex: '999999', background: '#fccb4f' }}>
                        1
                      </span>
                      <div className='number-sonar position-absolute' style={{ zIndex: '1px', background: '#fccb4f' }}></div>
                    </div>
                    Personal Information
                  </h4>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 1 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='mb-4'>Incorrect spelling of your name, different aliases, unknown addresses, and other personal information could be wrong on your reports. Credit Reporting agencies make errors like these all the time, and this incorrect information could have derogatory items attached to them that may not belong to you. It is important to make sure that all of the information reporting in this area of your reports is 100% accurate.</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block second-step'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at credit audit'));
                    setShowStep1Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* STEP 2 */}

        <Row>
          {/* MOBILE  */}
          <Col xs={currentStep === 2 ? 12 : 12} className='col-transition d-md-block d-lg-none'>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3'>Derogatory Items</h4>
                  <div className='sonar-wrapper'>
                    <Info
                      className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger'
                      width={34}
                      height={34}
                      strokeWidth={2}
                      onClick={() => {
                        setCurrentStep(2);
                        // handleSetCurrentStep(2);
                      }}
                    />
                    <div className='sonar-effect position-absolute'></div>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 2 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Since revolving credit makes up almost a whole third of your entire scores, keeping and maintaining a low balance is essential to having a high score. High balances will only cause you damage to your scores, and they can usually lead to you being late on your payments. We recommend to have your balances paid off to 30% or below the card’s respected limit. You can literally see the impact of paying your balances down from one report to another once the information has been updated!</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Derogatory Items'));
                    setShowStep2Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            <Image id='robot-path' src={Step2} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>

          {/* NORMAL  */}
          <Col lg={currentStep === 2 ? 4 : 2} className='position-absolute col-transition d-none d-lg-block' style={{ top: '640px', right: '290px', zIndex: '89' }}>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3 d-flex align-items-center flex-row'>
                    <div
                      className='d-flex position-relative'
                      onClick={() => {
                        setCurrentStep(2);
                        // handleSetCurrentStep(1);
                      }}>
                      <span className='icon d-flex me-3 p-3 text-white third-step' style={{ zIndex: '999999', background: '#ff9000' }}>
                        2
                      </span>
                      <div className='number-sonar position-absolute' style={{ zIndex: '1px', background: '#ff9000' }}></div>
                    </div>
                    Derogatory Items
                  </h4>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 2 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Since revolving credit makes up almost a whole third of your entire scores, keeping and maintaining a low balance is essential to having a high score. High balances will only cause you damage to your scores, and they can usually lead to you being late on your payments. We recommend to have your balances paid off to 30% or below the card’s respected limit. You can literally see the impact of paying your balances down from one report to another once the information has been updated!</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Derogatory Items'));
                    setShowStep2Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          {/* STEP 3 */}
          {/* MOBILE */}
          <Col xs={currentStep === 3 ? 12 : 12} className='col-transition d-md-block d-lg-none'>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3'>Credit Utilization</h4>
                  <div className='sonar-wrapper'>
                    <Info
                      className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger'
                      width={34}
                      height={34}
                      strokeWidth={2}
                      onClick={() => {
                        setCurrentStep(3);
                        // handleSetCurrentStep(3);
                      }}
                    />
                    <div className='sonar-effect position-absolute'></div>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 3 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Since revolving credit makes up almost a whole third of your entire scores, keeping and maintaining a low balance is essential to having a high score. High balances will only cause you damage to your scores, and they can usually lead to you being late on your payments. We recommend to have your balances paid off to 30% or below the card’s respected limit. You can literally see the impact of paying your balances down from one report to another once the information has been updated!</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Credit Utilization'));
                    setShowStep3Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            <Image id='robot-path' src={Step3} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>
          {/* NORMAL */}
          <Col lg={currentStep === 3 ? 4 : 2} className='position-absolute col-transition d-none d-lg-block' style={{ top: '840px', left: '300px', zIndex: '88' }}>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3 d-flex align-items-center flex-row'>
                    <div
                      className='d-flex position-relative'
                      onClick={() => {
                        setCurrentStep(3);
                        // handleSetCurrentStep(1);
                      }}>
                      <span className='icon d-flex me-3 p-3 text-white' style={{ zIndex: '999999', background: '#c700af' }}>
                        3
                      </span>
                      <div className='number-sonar position-absolute' style={{ zIndex: '1px', background: '#c700af' }}></div>
                    </div>
                    Credit Utilization
                  </h4>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 3 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Since revolving credit makes up almost a whole third of your entire scores, keeping and maintaining a low balance is essential to having a high score. High balances will only cause you damage to your scores, and they can usually lead to you being late on your payments. We recommend to have your balances paid off to 30% or below the card’s respected limit. You can literally see the impact of paying your balances down from one report to another once the information has been updated!</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Credit Utilization'));
                    setShowStep3Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* STEP 4 */}
        <Row>
          {/* MOBILE */}
          <Col xs={currentStep === 4 ? 12 : 12} className='col-transition d-md-block d-lg-none'>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3'>Credit History</h4>
                  <div className='sonar-wrapper'>
                    <Info
                      className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger'
                      width={34}
                      height={34}
                      strokeWidth={2}
                      onClick={() => {
                        setCurrentStep(4);
                        // handleSetCurrentStep(4);
                      }}
                    />
                    <div className='sonar-effect position-absolute'></div>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 4 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Credit history is a record of how you've managed the repayment of debts, such as credit cards and loans. Your goal should be to eastablish POSITIVE credit history overtime. From the moment you first start using your credit, your credit history begins to build. As the years go on, your credit history will help paint a picture of your responsibility as a borrower. Let’s learn more about what your Credit History says about you!</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Credit History'));
                    setShowStep4Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            <Image id='robot-path' src={Step4} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>
          {/* NORMAL */}
          <Col lg={currentStep === 4 ? 4 : 2} className='position-absolute col-transition d-none d-lg-block' style={{ top: '1010px', right: '390px', zIndex: '87' }}>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3 d-flex align-items-center flex-row'>
                    <div
                      className='d-flex position-relative'
                      onClick={() => {
                        setCurrentStep(4);
                        // handleSetCurrentStep(1);
                      }}>
                      <span className='icon d-flex me-3 p-3 text-white' style={{ zIndex: '999999', background: '#7200cc' }}>
                        4
                      </span>
                      <div className='number-sonar position-absolute' style={{ zIndex: '1px', background: '#7200cc' }}></div>
                    </div>
                    Credit History
                  </h4>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 4 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Credit history is a record of how you've managed the repayment of debts, such as credit cards and loans. Your goal should be to eastablish POSITIVE credit history overtime. From the moment you first start using your credit, your credit history begins to build. As the years go on, your credit history will help paint a picture of your responsibility as a borrower. Let’s learn more about what your Credit History says about you!</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Credit History'));
                    setShowStep4Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* STEP 5 */}
        <Row>
          {/* MOBILE */}
          <Col xs={currentStep === 5 ? 12 : 12} className='col-transition d-md-block d-lg-none'>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3'>Debt Owed</h4>
                  <div className='sonar-wrapper'>
                    <Info
                      className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger'
                      width={34}
                      height={34}
                      strokeWidth={2}
                      onClick={() => {
                        setCurrentStep(5);
                        // handleSetCurrentStep(1);
                      }}
                    />
                    <div className='sonar-effect position-absolute'></div>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 5 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Your Debt/Credit Ratio is very important when you are trying to gain new credit such as a loan or new credit card. You may be denied simply because a lender may conclude that you are not in a position to add a new account to your credit reports. It is important to not only make your payments on time, but also to game plan ways to lower your overall debt reporting on your credit reports. This could mean making more than just the monthly minimum payment required in order to pay accounts off quicker. Let’s explore what you can do to improve your Debt/Credit Ratio.</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Debt Owed'));
                    setShowStep5Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12}>
            <Image id='robot-path' src={Step5} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>
          {/* NORMAL */}
          <Col lg={currentStep === 5 ? 4 : 2} className='position-absolute col-transition d-none d-lg-block' style={{ top: '1180px', left: '230px', zIndex: '86' }}>
            <Card className='rounded-4 shadow border-0 p-3'>
              <Card.Header className='rounded-4 border-0 bg-white p-3'>
                <div className='d-flex justify-content-between align-content-center'>
                  <h4 className='lh-1 my-auto me-3 d-flex align-items-center flex-row'>
                    <div
                      className='d-flex position-relative'
                      onClick={() => {
                        setCurrentStep(5);
                        // handleSetCurrentStep(1);
                      }}>
                      <span className='icon d-flex me-3 p-3 text-white' style={{ zIndex: '999999', background: '#0a2cc3' }}>
                        5
                      </span>
                      <div className='number-sonar position-absolute' style={{ zIndex: '1px', background: '#0a2cc3' }}></div>
                    </div>
                    Debt Owed
                  </h4>
                </div>
              </Card.Header>
              <Card.Body className={`${currentStep === 5 ? 'd-show' : 'd-none'} pt-0`}>
                <div className='d-show mb-3'>Your Debt/Credit Ratio is very important when you are trying to gain new credit such as a loan or new credit card. You may be denied simply because a lender may conclude that you are not in a position to add a new account to your credit reports. It is important to not only make your payments on time, but also to game plan ways to lower your overall debt reporting on your credit reports. This could mean making more than just the monthly minimum payment required in order to pay accounts off quicker. Let’s explore what you can do to improve your Debt/Credit Ratio.</div>
                <Button
                  variant='outline-danger'
                  className='w-50 ms-auto me-3 d-block'
                  size='lg'
                  onClick={() => {
                    dispatch(callUserActvity('Click on personal info at Debt Owed'));
                    setShowStep5Modal(true);
                  }}>
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* STEP 6 */}
        <Row>
          {/* MOBILE */}
          <Col xs={currentStep === 6 ? 12 : 12} className='col-transition d-md-block d-lg-none'>
            <Button
              variant='primary'
              className='w-50 ms-auto me-3 fs-3 d-block rounded-5'
              size='lg'
              onClick={() => {
                dispatch(callUserActvity('Click on personal info at Solutions'));
                setShowStep6Modal(true);
              }}>
              Solutions
            </Button>
          </Col>
          <Col xs={12}>
            <Image id='robot-path' src={Step6} alt='robot-path' fluid className='d-lg-none d-block mx-auto' style={{ zIndex: 9 }} />
          </Col>
          {/* NORMAL */}
          <Col lg={currentStep === 6 ? 4 : 2} className='position-relative col-transition d-none d-lg-block' style={{ top: '870px', left: '790px', zIndex: '10' }}>
            <Button
              variant='primary'
              className='w-xl-75 w-lg-100 ms-auto me-3 fs-3 d-block rounded-5 position-absolute'
              size='lg'
              onClick={() => {
                dispatch(callUserActvity('Click on personal info at Solutions'));
                setShowStep6Modal(true);
              }}>
              Solutions
            </Button>
          </Col>
        </Row>
        <div id='bottom-space'></div>
        <Row className='my-5'>
          <Col lg='8' className='mx-auto'>
            <Card
              className='rounded-4 border-0 shadow p-4 mb-0 bg-primary'
              style={{
                backgroundImage: `url(${finishLineShapes})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
              }}>
              <Card.Body>
                <Row>
                  <Col lg='12' className='mb-3'>
                    <h2 className='mt-0 mb-2 text-white'>Finish Line!</h2>
                    <p className='mb-0 text-regular-16 text-white'>Your credit improvement path ends with you reaching your potential score after following the steps customized just for you..</p>
                  </Col>
                  <Col>
                    <Card className='border-0 rounded-4 shadow mb-3 mb-lg-0'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>Equifax</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {potentialScore.equifax || 0}
                          </div>

                          <div className={`d-flex my-auto me-0 px-4 py-2 ${potentialScore.equifaxPresentage >= 0 ? 'text-success' : 'text-danger'} badge ${potentialScore.equifaxPresentage >= 0 ? 'bg-success' : 'bg-danger'} bg-opacity-25`}>
                            <span style={{ fontSize: '19px', fontWeight: '500' }}>
                              {' '}
                              {potentialScore.equifaxPresentage >= 0 ? <Plus size='10' fill='currentColor' className='me-2' /> : <Minus size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />} {Math.abs(potentialScore.equifaxPresentage)}
                            </span>
                          </div>
                        </div>
                        <div className='d-flex'>
                          <div>
                            <span
                              style={{
                                fontSize: '0px',
                                display: 'inline-flex',
                                margin: 'auto 1rem',
                              }}
                              className={`bg-${getScoreColor[potentialScore.equifaxLabel]} p-1 rounded-circle mx-auto me-2`}></span>
                          </div>
                          <div className='text-normal-16 fw-light text-black'>{potentialScore.equifaxLabel}</div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col>
                    <Card className='border-0 rounded-4 shadow mb-3 mb-lg-0'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>Experian</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {potentialScore.experian || 0}
                          </div>

                          <div className={`d-flex my-auto me-0 px-4 py-2 ${potentialScore.experianPresentage >= 0 ? 'text-success' : 'text-danger'}  badge ${potentialScore.experianPresentage >= 0 ? 'bg-success' : 'bg-danger'}  bg-opacity-25`}>
                            <span style={{ fontSize: '19px', fontWeight: '500' }}>
                              {' '}
                              {potentialScore.experianPresentage >= 0 ? <Plus size='10' fill='currentColor' className='me-2' /> : <Minus size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />}
                              {Math.abs(potentialScore.experianPresentage)}
                            </span>
                          </div>
                        </div>
                        <div className='d-flex'>
                          <div>
                            <span
                              style={{
                                fontSize: '0px',
                                display: 'inline-flex',
                                margin: 'auto 1rem',
                              }}
                              className={`bg-${getScoreColor[potentialScore.experianLabel]} p-1 rounded-circle mx-auto me-2`}></span>
                          </div>
                          <div className='text-normal-16 fw-light text-black'>{potentialScore.experianLabel}</div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col>
                    <Card className='border-0 rounded-4 shadow mb-3 mb-lg-0'>
                      <Card.Body className='p-4'>
                        <div className='text-regular-18 fw-light'>TransUnion</div>
                        <div className='d-flex justify-content-between m-auto align-content-center'>
                          <div className='fw-semibold text-dark-blue' style={{ fontSize: '30px' }}>
                            {' '}
                            {potentialScore.transunion || 0}
                          </div>

                          <div className={`d-flex my-auto me-0 px-4 py-2 ${potentialScore.transunionPresentage >= 0 ? 'text-success' : 'text-danger'} badge ${potentialScore.transunionPresentage >= 0 ? 'bg-success' : 'bg-danger'}  bg-opacity-25`}>
                            <span style={{ fontSize: '19px', fontWeight: '500' }}>
                              {' '}
                              {potentialScore.transunionPresentage >= 0 ? <Plus size='10' fill='currentColor' className='me-2' /> : <Minus size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />}
                              {Math.abs(potentialScore.transunionPresentage)}
                            </span>
                          </div>
                        </div>
                        <div className='d-flex'>
                          <div>
                            <span
                              style={{
                                fontSize: '0px',
                                display: 'inline-flex',
                                margin: 'auto 1rem',
                              }}
                              className={`bg-${getScoreColor[potentialScore.transunionLabel]}  p-1 rounded-circle mx-auto me-2`}></span>
                          </div>
                          <div className='text-normal-16 fw-light text-black'>{potentialScore.transunionLabel}</div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <style>
        {`
        .modal-content {
            border-radius: var(--bs-border-radius-xl) !important;
        }
        `}
      </style>
      <Modal className='rounded-4' size='xl' show={step1Modal} onHide={() => setShowStep1Modal(false)} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='bg-light border-0 rounded-4 fw-normal fw-light' style={{ fontSize: '13px' }} closeButton>
          &nbsp;
        </Modal.Header>
        <Modal.Body className='mobile-overflow-x-auto bg-light rounded-4 px-md-5 px-3 pt-0'>
          <div className='h3 text-black'>Personal Information</div>
          <div className='text-black mb-3'>Incorrect spelling of your name, different aliases, unknown addresses, and other personal information could be wrong on your reports. Credit Reporting agencies make errors like these all the time, and this incorrect information could have derogatory items attsached to them that may not belong to you. It is important to make sure that all of the information reporting in this area of your reports is 100% accurate.</div>
          <Card className='rounded-4 border-0 p-3'>
            <Card.Body className='rounded-4 border-0'>
              <Table borderless responsive id='personalInfoModal' className='rounded-4 mb-0 mobile-overflow-x-auto' style={{ tableLayout: 'auto' }}>
                <style>{`th  {
                  color: 'var(--bs-gray-400)',
                  fontWeight: '300',
                  cursor: 'pointer',
                  border: 0;
                }
                thead {
                  border:0;
                }
                td, th {
                  padding: 1rem !important;
                }
                #personalInfoModal thead th {
                padding: 1rem 2rem !important;
                border: solid transparent 0px;
                }
                #personalInfoModal {
                width: 100%;
                border-collapse: inherit;
                table-layout: fixed;
                text-align: center;
                font: 13px Verdana;
                border-radius: 30px;
                border-spacing: 0px;
                background: white;
                }

                #personalInfoModal thead th {
                border: none;
                padding: 20px;
                background: #F8F9FD;
                color: var(--bs-gray-400);
                border-left: none;
                }

                #personalInfoModal thead tr {
                background:white;
                }

                #personalInfoModal thead tr:first-child td:first-child {
                border-radius: 20px 0 0 20px;
                }

                #personalInfoModal thead tr:first-child td:last-child {
                border-radius: 0 20px 20px 0;
                }

                #personalInfoModal tbody th {
                padding: 20px;
                font-size: 13px
                font-weight:normal !important;
                }
                .btn-close {
                  font-size: 13px
                  font-weight: 300;
                }

                `}</style>
                <thead className='rounded-4' style={{ backgroundColor: 'rgb(248, 249, 253)' }}>
                  <tr className='bordor-0 rounded-4  text-light-gray fw-normal'>
                    {/* <th className='rounded-4 fw-normal' style={{ borderRadius: '20px 0 0 0' }}>
                      Credit Bureau
                    </th> */}
                    {/* <th className='fw-normal'>Credit Report Date</th> */}
                    <th className='fw-normal'>Name</th>
                    <th className='fw-normal'>Date Of Birth</th>
                    <th className='fw-normal' style={{ borderRadius: '20px 0 0 20px' }}>
                      Address
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='p-2'>
                    {/* <td>TransUnion</td> */}
                    {/* <td>6 June 2022</td> */}
                    <td className='position-relative'>
                      {verify_info_logs.first_name?.original} {verify_info_logs.last_name?.original}
                      {verify_info_logs && ['first_name', 'last_name'].map(key => eval(verify_info_logs[key]?.changed)).includes(1) ? (
                        <div
                          className='sonar-wrapper'
                          style={{
                            position: 'absolute',
                            top: '1px',
                            right: '30%',
                            transform: 'scale(.7)',
                          }}>
                          <OverlayTrigger
                            trigger='focus'
                            placement='bottom'
                            overlay={
                              <Popover className='bg-white border-0 ' id='name-popover'>
                                <Popover.Header className='bg-white'>
                                  <h5>Potential name error on your report</h5>
                                </Popover.Header>
                                <Popover.Body>
                                  <p>
                                    {verify_info_logs.first_name?.current} {verify_info_logs.last_name?.current}
                                  </p>
                                </Popover.Body>
                              </Popover>
                            }>
                            <Info className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger' width={34} height={34} strokeWidth={2} tabIndex={0} />
                          </OverlayTrigger>
                          <div className='sonar-effect position-absolute'></div>
                        </div>
                      ) : (
                        <div
                          style={{
                            position: 'absolute',
                            top: '1px',
                            right: '30%',
                            transform: 'scale(.7)',
                          }}>
                          <Check className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-success' width={34} height={34} strokeWidth={2} tabIndex={0} />
                        </div>
                      )}
                    </td>
                    <td className='position-relative'>
                      {verify_info_logs.dob?.original ? moment(verify_info_logs.dob?.original).format('MM/DD/YYYY') : ''}
                      {verify_info_logs && ['dob'].map(key => eval(verify_info_logs[key]?.changed)).includes(1) ? (
                        <div
                          className='sonar-wrapper'
                          style={{
                            position: 'absolute',
                            top: '1px',
                            right: '30%',
                            transform: 'scale(.7)',
                          }}>
                          <OverlayTrigger
                            trigger='focus'
                            placement='bottom'
                            overlay={
                              <Popover className='bg-white border-0 ' id='name-popover'>
                                <Popover.Header className='bg-white'>
                                  <h5>Potential date of birth error on your report</h5>
                                </Popover.Header>
                                <Popover.Body>
                                  <p>{verify_info_logs.dob?.current ? moment(verify_info_logs.dob?.current).format('MM/DD/YYYY') : ''}</p>
                                </Popover.Body>
                              </Popover>
                            }>
                            <Info className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger' width={34} height={34} strokeWidth={2} tabIndex={0} />
                          </OverlayTrigger>
                          <div className='sonar-effect position-absolute'></div>
                        </div>
                      ) : (
                        <div
                          style={{
                            position: 'absolute',
                            top: '1px',
                            right: '30%',
                            transform: 'scale(.7)',
                          }}>
                          <Check className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-success' width={34} height={34} strokeWidth={2} tabIndex={0} />
                        </div>
                      )}
                    </td>
                    <td className='position-relative'>
                      {`${verify_info_logs.address?.original || ''} ${verify_info_logs.address2?.original || ''} ${verify_info_logs.country?.original || ''} ${verify_info_logs.state?.original || ''} ${verify_info_logs.zip?.original || ''}`}
                      {verify_info_logs && ['address', 'address2', 'country', 'state', 'zip'].map(key => eval(verify_info_logs[key]?.changed)).includes(1) ? (
                        <div
                          className='sonar-wrapper'
                          style={{
                            position: 'absolute',
                            top: '1px',
                            right: '28%',
                            transform: 'scale(.7)',
                          }}>
                          <OverlayTrigger
                            trigger='focus'
                            placement='bottom'
                            overlay={
                              <Popover className='bg-white border-0 ' id='transunion-popover'>
                                <Popover.Header className='bg-white'>
                                  <h6>Potential address error on your report</h6>
                                </Popover.Header>
                                <Popover.Body>
                                  <p>{`${verify_info_logs.address?.current || ''} ${verify_info_logs.address2?.current || ''} ${verify_info_logs.country?.current || ''},${verify_info_logs.state?.current || ''} ${verify_info_logs.zip?.current || ''}`}</p>
                                </Popover.Body>
                              </Popover>
                            }>
                            <Info className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-danger' width={34} height={34} strokeWidth={2} tabIndex={0} />
                          </OverlayTrigger>
                          <div className='sonar-effect position-absolute'></div>
                        </div>
                      ) : (
                        <div
                          style={{
                            position: 'absolute',
                            top: '1px',
                            right: '28%',
                            transform: 'scale(.7)',
                          }}>
                          <Check className='p-1 more-info StyledInfo position-absolute rounded-circle text-white bg-success' width={34} height={34} strokeWidth={2} tabIndex={0} />
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Modal.Body>
        <style>
          {`


.ribbon-wrapper {
	position: absolute;
	top: 40px;
	right: -4px;
	width: 210px;
	height: 100px;
	overflow: hidden;
}

.ribbon {
	--f: 10px;
	--r: 15px;
	--t: 10px;
	position: absolute;
	inset: var(--t) calc(-1*var(--f)) auto auto;
	padding: 0 20px var(--f) calc(10px + var(--r));
	clip-path: polygon(0 0,100% 0,100% calc(100% - var(--f)),calc(100% - var(--f)) 100%, calc(100% - var(--f)) calc(100% - var(--f)),0 calc(100% - var(--f)), var(--r) calc(50% - var(--f)/2));
	background: #000E4E;
	box-shadow: 0 calc(-1*var(--f)) 0 inset #0005;
	height: 50px;
	line-height: 2.5;
	color: white;
}


          `}
        </style>
        <div className='ribbon-wrapper'>
          <div className='ribbon bg-primary'>Enhanced Only</div>
        </div>
      </Modal>
      {/** Step 2 */}
      <Modal className='rounded-4' size='xl' show={step2Modal} onHide={() => setShowStep2Modal(false)} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='bg-light border-0 rounded-4 fw-normal fw-light' closeButton style={{ color: 'red' }}></Modal.Header>
        <Modal.Body className='bg-light rounded-4 px-md-5 px-3 pt-0'>
          <div className='h3 text-black'>Derogatory items</div>
          <div className='text-black mb-3'>Accounts, Inquiries, and Public Records that are reporting negative on your credit reports are going to be causing the most damage to your credit scores. Luckily, US Consumers can leverage the FCRA Laws to dispute any and all information being reported on credit reports. This forces the bureaus to investigate and ensure that the information they are reporting is accurate and compliant with the laws established by the federal government! Check out your options on what to do about these damaging items.</div>
          <Card className='rounded-4 border-0 p-3'>
            <Card.Body className='rounded-4 border-0'>
              <Table borderless responsive id='derogatoryItemsModal' className='rounded-4 mb-0 mobile-overflow-x-auto' style={{ tableLayout: 'auto' }} data={tableData}>
                <style>{`th  {
                  color: 'var(--bs-gray-400)',
                  fontWeight: '300',
                  cursor: 'pointer',
                  border: 0;
                }
                thead {
                  border:0;
                }
                td, th {
                  padding: 1rem !important;
                }
                #derogatoryItemsModal thead th {
                padding: 1rem 2rem !important;
                border: solid transparent 0px;
                }
                #derogatoryItemsModal {
                width: 100%;
                border-collapse: inherit;
                table-layout: fixed;
                text-align: center;
                font: 13px Verdana;
                border-radius: 30px;
                border-spacing: 0px;
                background: white;
                }

                #derogatoryItemsModal thead th {
                border: none;
                padding: 20px;
                background: #F8F9FD;
                color: var(--bs-gray-400);
                border-left: none;
                }

                #derogatoryItemsModal thead tr {
                background:white;
                }

                #derogatoryItemsModal thead tr:first-child td:first-child {
                border-radius: 20px 0 0 20px;
                }

                #derogatoryItemsModal thead tr:first-child td:last-child {
                border-radius: 0 20px 20px 0;
                }

                #derogatoryItemsModal tbody th {
                padding: 20px;
                font-size: 13px
                font-weight:normal !important;
                }
                .btn-close {
                  font-size: 13px
                  font-weight: 300;
                }

                `}</style>
                <thead className='rounded-4' style={{ backgroundColor: 'rgb(248, 249, 253)' }}>
                  <tr className='bordor-0 rounded-4  text-light-gray fw-normal'>
                    <th className='fw-normal' style={{ borderRadius: '20px 0 0 20px' }}>
                      Account Name
                    </th>
                    <th className='fw-normal'>Account Status</th>
                    <th className='fw-normal'>Experian</th>
                    <th className='fw-normal'>Equifax</th>
                    <th className='fw-normal' style={{ borderRadius: '20px 0 0 20px' }}>
                      TransUnion
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {derogatory_items.length > 0 ? (
                    <>
                      {derogatory_items.map(data => {
                        let color = {
                          Negative: 'danger',
                          'Not Reporting': 'secondary',
                          VERIFIED: 'danger',
                          'New Negative': 'danger',
                          DELETED: 'success',
                          REPAIRED: 'success',
                          DND: 'secondary',
                        };
                        let badgeClass = id => `px-2 py-2 bg-opacity-25 fw-normal text-capitalize fs-6 text-${color[id]}`;

                        return (
                          <tr className='p-2'>
                            <td className='text-dark-blue fs-6' dangerouslySetInnerHTML={{ __html: data.name }}></td>
                            <td className='text-dark-blue fs-6'>{data.payment_type}</td>
                            <td>
                              {data.Experian !== '' && (
                                <Badge bg={`${color[data.Experian]}`} className={badgeClass(data.Experian)}>
                                  {data.Experian.toLowerCase() === 'dnd' ? 'Not Disputing' : data.Experian.toLowerCase()}
                                </Badge>
                              )}{' '}
                            </td>
                            <td>
                              {data.Equifax !== '' && (
                                <Badge bg={`${color[data.Equifax]}`} className={badgeClass(data.Equifax)}>
                                  {data.Equifax.toLowerCase() === 'dnd' ? 'Not Disputing' : data.Equifax.toLowerCase()}
                                </Badge>
                              )}{' '}
                            </td>
                            <td>
                              {data.Transunion !== '' && (
                                <Badge bg={`${color[data.Transunion]}`} className={badgeClass(data.Transunion)}>
                                  {data.Transunion.toLowerCase() === 'dnd' ? 'Not Disputing' : data.Transunion.toLowerCase()}
                                </Badge>
                              )}{' '}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : null}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
      {/** Step 3 */}
      <Modal className='rounded-4' size='xl' show={step3Modal} onHide={() => setShowStep3Modal(false)} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='bg-light border-0 rounded-4 fw-normal fw-light' closeButton style={{ color: 'red' }}></Modal.Header>
        <Modal.Body className='bg-light rounded-4 px-md-5 px-3 pt-0'>
          <div className='h3 text-black'>Credit Utilization</div>
          <div className='text-black mb-3'>Since revolving credit makes up almost a whole third of your entire scores, keeping and maintaining a low balance is essential to having a high score. High balances will only cause you damage to your scores, and they can usually lead to you being late on your payments. We recommend to have your balances paid off to 30% or below the card’s respected limit. You can literally see the impact of paying your balances down from one report to another once the information has been updated!</div>
          <Card className='rounded-4 border-0 p-3'>
            <Card.Body className='rounded-4 border-0'>
              <Table borderless responsive id='creditUtilizationModal' className='rounded-4 mb-0 mobile-overflow-x-auto' style={{ tableLayout: 'auto' }}>
                <style>{`
            #creditUtilizationModal {
              width: 100%;
              border-collapse: separate;
              table-layout: fixed;
              text-align: center;
              font: 13px Verdana;
              border-radius: 30px;
              border-spacing: 0px;
              background: white;
            }
            #creditUtilizationModal thead th {
              border: none;
              padding: 20px;
              background: #F8F9FD;
              color: var(--bs-gray-400);
              border-left: none;
              font-weight: 300;
              font-size: 13px
              border-radius: 20px 0 0 20px;
              text-align: left;
            }
            #creditUtilizationModal tbody td {
              padding: 1rem !important;
              font-size: 13px
            }

            }
            #creditUtilizationModal tbody tr:hover {
              background-color: #E6E7EE;
            }
            #creditUtilizationModal thead tr {
              background:white;
            }
            #creditUtilizationModal thead tr:first-child td:first-child {
              border-radius: 20px 0 0 20px;
            }
            #creditUtilizationModal thead tr:first-child td:last-child {
              border-radius: 0 20px 20px 0;
            }
            #creditUtilizationModal td:first-child {
              text-align: left;
              font-weight: 500;
            }
            .btn-close {
              font-size: 13px
              font-weight: 300;
              color: #212529;
            }
            th, td {
              text-align:center !important;
            }
          `}</style>
                <thead className='rounded-pill bg-light border-0'>
                  <tr className='border-0'>
                    <th className='rounded-start-4'>Account</th>
                    <th>Reporting</th>
                    <th className='rounded-end-4'>Balance / Limit</th>
                  </tr>
                </thead>
                <tbody>
                  {credit_utilizations.length > 0 ? (
                    <>
                      {credit_utilizations.map(credit_utilization => (
                        <tr className='p-2'>
                          <td className='text-dark-blue fs-6'>{credit_utilization.name}</td>
                          <td>
                            {credit_utilization.Equifax !== 'Not Reporting' ? <img src={Equifax} width={80} alt='Equifax' className='mx-3' /> : <img src={Equifax} width={80} alt='Not Reporting' className='mx-3' style={{ visibility: 'hidden' }} />}
                            {credit_utilization.Experian !== 'Not Reporting' ? <img src={Experian} width={80} alt='Experian' className='mx-3' /> : <img src={Experian} width={80} alt='Not Reporting' className='mx-3' style={{ visibility: 'hidden' }} />}
                            {credit_utilization.TransUnion !== 'Not Reporting' ? <img src={TransUnion} width={80} alt='TransUnion' className='mb-2 mx-3' /> : <img src={TransUnion} width={80} alt='Not Reporting' className='mb-2 mx-3' style={{ visibility: 'hidden' }} />}
                          </td>
                          <td className='text-dark-blue fs-6'>
                            ${parseFloat(formatValue(credit_utilization.final_balance))?.toLocaleString()} / ${parseFloat(formatValue(credit_utilization.final_limit))?.toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={3} align='center'>
                        No revolving credit found! Visit our Credit Builder for information on how to change that!
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
      {/** Step 4 */}
      <Modal className='rounded-4' size='xl' show={step4Modal} onHide={() => setShowStep4Modal(false)} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='bg-light border-0 rounded-4 fw-normal fw-light' closeButton style={{ color: 'red' }}></Modal.Header>
        <Modal.Body className='bg-light rounded-4 px-md-5 px-3 pt-0'>
          <div className='h3 text-black'>Credit History</div>
          <div className='text-black mb-3'>Credit history is a record of how you've managed the repayment of debts, such as credit cards and loans. Your goal should be to eastablish POSITIVE credit history overtime. From the moment you first start using your credit, your credit history begins to build. As the years go on, your credit history will help paint a picture of your responsibility as a borrower. Let’s learn more about what your Credit History says about you!</div>
          <Row className='mt-3'>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Total Revolving Accounts' icon={Pages} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_revolving_accounts : 0} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Total Installment Accounts' icon={Installment} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_installment_accounts : 0} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Credit Utilization' icon={Dollar} value={`${creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.credit_utilization_percentage : 0}%`} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Total Positive Accounts' icon={Bull} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_positive_count : 0} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Total Negative Accounts' icon={Bear} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_negative_count : 0} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Start of credit history' icon={null} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.start_of_credit_history : 'NA'} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Total Ontime Payments' icon={null} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.total_ontime_payment_count : '0'} />
            </Col>
            <Col xs='12' md='6' className='mb-3'>
              <CreditSummary title='Current Credit Rating' icon={StarIcon} value={creditSummary && Object.keys(creditSummary).length > 0 ? creditSummary.current_credit_rating : 'NA'} />
            </Col>
          </Row>
          <Card className='rounded-4 border-0 p-3'>
            <Card.Body className='rounded-4 border-0 mobile-overflow-x-auto'>
              <style>{`
            #creditUtilizationModal {
              width: 100%;
              border-collapse: separate;
              table-layout: fixed;
              text-align: center;
              font: 13px Verdana;
              border-radius: 30px;
              border-spacing: 0px;
              background: white;
            }
            #creditUtilizationModal thead th {
              border: none;
              padding: 20px;
              background: #F8F9FD;
              color: var(--bs-gray-400);
              border-left: none;
              font-weight: 300;
              font-size: 13px
              border-radius: 20px 0 0 20px;
              text-align: left;
            }
            #creditUtilizationModal tbody td {
              padding: 1rem !important;
              font-size: 13px
            }
th:nth-child(1) {
	border-bottom-left-radius: var(--bs-border-radius-xl) !important;
	border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: 0 !important;
	border-top-left-radius: 0 !important;
}
            }
            #creditUtilizationModal tbody tr:hover {
              background-color: #E6E7EE;
            }
            #creditUtilizationModal thead tr {
              background:white;
            }
            #creditUtilizationModal thead tr:first-child td:first-child {
              border-radius: 20px 0 0 20px;
            }
            #creditUtilizationModal thead tr:first-child td:last-child {
              border-radius: 0 20px 20px 0;
            }
            #creditUtilizationModal td:first-child {
              text-align: left;
              font-weight: 500;
            }
            .btn-close {
              font-size: 13px
              font-weight: 300;
              color: #212529;
            }
            th, td {
              text-align:center !important;
            }
          `}</style>
              <CurrentProcess cpData={cpData} handleChartYearChange={handleChartYearChange} year={historyYear} />
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
      {/** Step 5 */}
      <Modal className='rounded-4' size='xl' show={step5Modal} onHide={() => setShowStep5Modal(false)} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='bg-light border-0 rounded-4 fw-normal fw-light' closeButton style={{ color: 'red' }}></Modal.Header>
        <Modal.Body className='bg-light rounded-4 px-md-5 px-3 pt-0'>
          <div className='h3 text-black'>Debt Owed</div>
          <div className='text-black mb-3'>Your Debt/Credit Ratio is very important when you are trying to gain new credit such as a loan or new credit card. You may be denied simply because a lender may conclude that you are not in a position to add a new account to your credit reports. It is important to not only make your payments on time, but also to game plan ways to lower your overall debt reporting on your credit reports. This could mean making more than just the monthly minimum payment required in order to pay accounts off quicker. Let’s explore what you can do to improve your Debt/Credit Ratio</div>
          <Card className='rounded-4 border-0 p-3'>
            <Card.Body className='rounded-4 border-0'>
              <style>{`
            #creditUtilizationModal {
              width: 100%;
              border-collapse: separate;
              table-layout: fixed; 
              text-align: center;
              font: 13px Verdana;
              border-radius: 30px;
              border-spacing: 0px;
              background: white;
            }
            #creditUtilizationModal thead th {
              border: none;
              padding: 20px;
              background: #F8F9FD;
              color: var(--bs-gray-400);
              border-left: none;
              font-weight: 300;
              font-size: 13px
              border-radius: 20px 0 0 20px;
              text-align: left;
            }
            #creditUtilizationModal tbody td {
              padding: 1rem !important;
              font-size: 13px
            }

            }
            #creditUtilizationModal tbody tr:hover {
              background-color: #E6E7EE;
            }
            #creditUtilizationModal thead tr {
              background:white;
            }
            #creditUtilizationModal thead tr:first-child td:first-child {
              border-radius: 20px 0 0 20px;
            }
            #creditUtilizationModal thead tr:first-child td:last-child {
              border-radius: 0 20px 20px 0;
            }
            #creditUtilizationModal td:first-child {
              text-align: left;
              font-weight: 500;
            }
            .btn-close {
              font-size: 13px
              font-weight: 300;
              color: #212529;
            }
            th, td {
              text-align:center !important;
            }
          `}</style>

              <div className='h3 mb-3 text-black'>Balance to Limit</div>
              <Card className='shadow border-0 rounded-4 fw-normal fw-light'>
                <Card.Body>
                  <Row>
                    <Col xs={12} md={4}>
                      <Row>
                        <Col xs={12} className='my-auto mb-3'>
                          <Card className='border-0 shadow rounded-3 mb-lg-auto h-100'>
                            <div className='d-flex p-3 rounded align-items-center'>
                              <div
                                className='d-flex bg-light-blue'
                                style={{
                                  borderRadius: '50%',
                                  height: '40px',
                                  width: '40px',
                                }}>
                                <div className='bg-transparent border border-primary border-2 text-center rounded-circle m-auto' style={{ padding: '0 2px' }}>
                                  <Check className='text-primary m-auto' width={18} height={12} strokeWidth={4} />
                                </div>
                              </div>
                              <div className='ps-3'>
                                <div className='text-light-gray fw-light lh-1 mb-2' style={{ fontSize: '15px', height: '30' }}>
                                  Total Revolving Balances
                                </div>
                                <div className='font-weight-bold h2 lh-1 mb-0'>${debt_owed_data.total_balance_revolving?.toLocaleString()}</div>
                              </div>
                            </div>
                          </Card>
                        </Col>
                        <Col xs={12} className='my-auto mb-3'>
                          <Card className='border-0 shadow rounded-3 mb-lg-auto h-100'>
                            <div className='d-flex p-3 rounded align-items-center'>
                              <div
                                className='d-flex bg-light-blue'
                                style={{
                                  borderRadius: '50%',
                                  height: '40px',
                                  width: '40px',
                                }}>
                                <div className='bg-transparent border border-primary border-2 text-center rounded-circle m-auto' style={{ padding: '0 2px' }}>
                                  <Check className='text-primary m-auto' width={18} height={12} strokeWidth={4} />
                                </div>
                              </div>
                              <div className='ps-3'>
                                <div className='text-light-gray fw-light lh-1 mb-2' style={{ fontSize: '15px', height: '30' }}>
                                  Total Installment Balances
                                </div>
                                <div className='font-weight-bold h2 lh-1 mb-0'>${debt_owed_data.total_balance_installment?.toLocaleString()}</div>
                              </div>
                            </div>
                          </Card>
                        </Col>
                        <Col xs={12} className='my-auto mb-3'>
                          <Card className='border-0 shadow rounded-3 mb-lg-auto h-100'>
                            <div className='d-flex p-3 rounded align-items-center'>
                              <div
                                className='d-flex bg-light-blue'
                                style={{
                                  borderRadius: '50%',
                                  height: '40px',
                                  width: '40px',
                                }}>
                                <div className='bg-transparent border border-primary border-2 text-center rounded-circle m-auto' style={{ padding: '0 2px' }}>
                                  <Check className='text-primary m-auto' width={18} height={12} strokeWidth={4} />
                                </div>
                              </div>
                              <div className='ps-3'>
                                <div className='text-light-gray fw-light lh-1 mb-2' style={{ fontSize: '15px', height: '30' }}>
                                  Total Combined Limits ($)
                                </div>
                                <div className='font-weight-bold h2 lh-1 mb-0'>${debt_owed_data.total_limit?.toLocaleString()}</div>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <Col xs={6} className='mx-auto my-auto mb-3'>
                          <ExpenseChart revBal={debt_owed_data.total_balance_revolving} InsBal={debt_owed_data.total_balance_installment} limit={debt_owed_data.total_limit} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Row>
                <Table borderless responsive id='personalInfoModal' className='rounded-4 mb-0 mobile-overflow-x-auto' style={{ tableLayout: 'auto' }} data={tableData}>
                  <style>{`th  {
                  color: 'var(--bs-gray-400)',
                  fontWeight: '300',
                  cursor: 'pointer',
                  border: 0;
                }
                thead {
                  border:0;
                }
                td, th {
                  padding: 1rem !important;
                }
                #personalInfoModal thead th {
                padding: 1rem 2rem !important;
                border: solid transparent 0px;
                }
                #personalInfoModal {
                width: 100%;
                border-collapse: inherit;
                table-layout: fixed;
                text-align: center;
                font: 13px Verdana;
                border-radius: 30px;
                border-spacing: 0px;
                background: white;
                }

                #personalInfoModal thead th {
                border: none;
                padding: 20px;
                background: #F8F9FD;
                color: var(--bs-gray-400);
                border-left: none;
                }

                #personalInfoModal thead tr {
                background:white;
                }

                #personalInfoModal thead tr:first-child td:first-child {
                border-radius: 20px 0 0 20px;
                }

                #personalInfoModal thead tr:first-child td:last-child {
                border-radius: 0 20px 20px 0;
                }

                #personalInfoModal tbody th {
                padding: 20px;
                font-size: 13px
                font-weight:normal !important;
                }
                .btn-close {
                  font-size: 13px
                  font-weight: 300;
                }

                `}</style>
                  <thead className='rounded-4' style={{ backgroundColor: 'rgb(248, 249, 253)' }}>
                    <tr className='bordor-0 rounded-4  text-light-gray fw-normal'>
                      <th className='fw-normal rounded-start-4'>Month</th>
                      <th className='fw-normal'>Total Revolving Debt</th>
                      <th className='fw-normal'>Total Installment Debt</th>
                      <th className='fw-normal'>Total Limits</th>
                      <th className='fw-normal'>Account Debt %</th>
                      <th className='fw-normal rounded-end-4'>Change</th>
                    </tr>
                  </thead>
                  <tbody>
                    {debt_owed_data?.data?.length > 0 ? (
                      debt_owed_data.data.map((row, index) => (
                        <tr key={index}>
                          <td>{moment(row.date).format('MMMM')}</td>
                          <td>${row.total_balance_revolving?.toLocaleString()}</td>
                          <td>${row.total_balance_installment?.toLocaleString()}</td>
                          <td>${row.total_limit?.toLocaleString()}</td>
                          <td>{Math.floor(((row.total_balance_revolving + row.total_balance_installment) / row.total_limit) * 100)}%</td>
                          <td>
                            {index === 0 ? (
                              '-'
                            ) : (
                              <div className={`d-flex my-auto me-0 px-4 py-2 ${calculateOwedChange(debt_owed_data.data, index) >= 0 ? 'text-success' : 'text-danger'}`}>
                                <span style={{ fontSize: '16px', fontWeight: '300' }}>
                                  {' '}
                                  {calculateOwedChange(debt_owed_data.data, index) >= 0 ? <Triangle size='10' fill='currentColor' className='me-2' /> : <Triangle size='10' fill='currentColor' className='me-2' style={{ transform: 'rotate(180deg)' }} />} {calculateOwedChange(debt_owed_data.data, index)}%
                                </span>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        {' '}
                        <td colSpan={6}>No data Available</td>{' '}
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>
      {/** Step 6 */}
      <Modal className='rounded-4' size='xl' show={step6Modal} onHide={() => setShowStep6Modal(false)} aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header className='bg-light border-0 rounded-4 fw-normal fw-light' closeButton style={{ color: 'red' }}></Modal.Header>
        <Modal.Body className='bg-light rounded-4 px-md-5 px-3 pt-0'>
          <div className='h3 text-black'>Solutions</div>
          <div className='text-black mb-3'>Addressing Negative Items</div>
          <style>{`
            #creditUtilizationModal {
              width: 100%;
              border-collapse: separate;
              table-layout: fixed; 
              text-align: center;
              font: 13px Verdana;
              border-radius: 30px;
              border-spacing: 0px;
              background: white;
            }
            #creditUtilizationModal thead th {
              border: none;
              padding: 20px;
              background: #F8F9FD;
              color: var(--bs-gray-400);
              border-left: none;
              font-weight: 300;
              font-size: 13px
              border-radius: 20px 0 0 20px;
              text-align: left;
            }
            #creditUtilizationModal tbody td {
              padding: 1rem !important;
              font-size: 13px
            }

            }
            #creditUtilizationModal tbody tr:hover {
              background-color: #E6E7EE;
            }
            #creditUtilizationModal thead tr {
              background:white;
            }
            #creditUtilizationModal thead tr:first-child td:first-child {
              border-radius: 20px 0 0 20px;
            }
            #creditUtilizationModal thead tr:first-child td:last-child {
              border-radius: 0 20px 20px 0;
            }
            #creditUtilizationModal td:first-child {
              text-align: left;
              font-weight: 500;
            }
            .btn-close {
              font-size: 13px
              font-weight: 300;
              color: #212529;
            }
            th, td {
              text-align:center !important;
            }
             @keyframes seesaw {
  0%, 16.67%, 100% {
    transform: rotate(0deg);
  }
  8.33% {
    transform: rotate(5deg);
  }
  25%, 41.67% {
    transform: rotate(0deg);
  }
  33.33% {
    transform: rotate(-5deg);
  }
  50%, 66.67% {
    transform: rotate(0deg);
  }
}

.seesaw {
  animation: seesaw 2s ease-in-out infinite;
  transform-origin: center bottom;
}
          `}</style>

          <Row className='d-flex flex-wrap'>
            <Col xs={12} md={4} className='mb-3'>
              <Card className='shadow border-0 p-4 mb-0 rounded-3 d-flex flex-column h-100'>
                <div className='d-flex flex-column h-100'>
                  <Card.Body className='py-1 flex-fill'>
                    <div className='d-block mb-2'>
                      <div className='d-flex flex-row justify-content-start align-content-center w-100'>
                        <div stroke='none' style={{ width: '38px', height: '38px' }} className='align-items-center justify-content-center p-1 bg-icon-red rounded-circle bg-opacity-50 d-flex shadow'>
                          <XCircle className='text-white' strokeWidth={2} style={{ height: '20px' }} />
                        </div>
                        <div className='d-flex justify-content-center align-items-center ms-4 text-medium-18'>Doing nothing</div>
                      </div>
                    </div>
                    <p className='p-2 text-regular-12'>Doing nothing about the incorrect/derogatory information on your reports is an option for someone who does not have the power of DisputeLy at their disposal! Some of the derogatory information may fall off a credit report within 7 years (statute of limitations), but you don’t have to wait that long to start disputing!</p>
                  </Card.Body>
                </div>
              </Card>
            </Col>
            <Col xs={12} md={4} className='mb-3'>
              <Card className='shadow border-0 p-4 mb-0 rounded-3 d-flex flex-column h-100'>
                <div className='d-flex flex-column h-100'>
                  <Card.Body className='py-1 flex-fill'>
                    <div className='d-block mb-2'>
                      <div className='d-flex flex-row justify-content-start align-content-center w-100'>
                        <div style={{ width: '38px', height: '38px' }} className='bg-icon-blue align-content-cnnter p-1 rounded-circle bg-opacity-50 d-flex shadow'>
                          <img src={standardStar} alt='standard star' fill='var(--bs-primary)' className='text-primary m-auto' width='17' height='17' stroke='0' />
                        </div>
                        <div className='d-flex justify-content-center align-items-center ms-4 text-medium-18'>Standard</div>
                      </div>
                    </div>

                    <p className='p-2 text-regular-12'>Every US consumer has the right to dispute information on their credit reports, so why not force the bureaus to investigate every aspect of your credit reports? If the credit bureaus find any errors during their investigation, they must remove the information that was disputed! Under the standard approach, DisputeLy will help you dispute against the 3 main credit bureaus!</p>
                  </Card.Body>
                </div>
              </Card>
            </Col>
            <Col xs={12} md={4} className='mb-3'>
              <Card className='shadow border-0 p-4 mb-0 rounded-3 d-flex flex-column h-100'>
                <div className='d-flex flex-column h-100'>
                  <Card.Body className='py-1 flex-fill'>
                    <div className='d-block mb-2'>
                      <div className='d-flex flex-row justify-content-start align-content-center w-100'>
                        <div style={{ width: '38px', height: '38px' }} className='bg-icon-blue align-content-center p-1 rounded-circle bg-opacity-50 d-flex shadow position-relative'>
                          <Mail className='position-absolute bg-warning align-content-center rounded-3 border border-2 border-warning text-white' width={15} height={15} style={{ right: '0', top: '0' }} />
                          <img src={standardStar} alt='standard star' fill='var(--bs-primary)' className='text-primary m-auto' width='17' height='17' stroke='0' />
                        </div>
                        <div className='d-flex justify-content-center align-items-center ms-4 text-medium-18'>Standard w/ Mailing</div>
                      </div>
                    </div>

                    <p className='p-2 text-regular-12'>Knowing that you can execute your rights to dispute any information on your credit reports, Dispute.ly made it even easier by offering to mail your letters out for you! That's right! Not only can you quickly generate dispute letters, but you can also take a seat back and relax, while dispute.ly does all the processing and mailing of your letters. Get your Dispute Letters out to the 3 Credit Bureaus ASAP, and start exercising your right to dispute!</p>
                  </Card.Body>
                </div>
              </Card>
            </Col>
            <Col xs={12} className='mb-3'>
              <Card className='shadow border-5 border-primary bg-primary p-4 mb-0 rounded-3 d-flex flex-column h-100' style={{ backgroundImage: `url(${BotAtlas})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'right' }}>
                <div className='d-flex flex-column h-100 w-60'>
                  <div className='position-relative'>
                    <Image src={GoldStar} className='img-fluid position-absolute' style={{ left: '170px', top: '0', width: '20px' }} />
                  </div>
                  <Card.Body className='py-1 flex-fill'>
                    <div className='d-block mb-2'>
                      <div className='d-flex flex-row justify-content-start align-content-center w-100'>
                        <div style={{ width: '38px', height: '38px' }} className='bg-icon-violet align-content-cnnter p-1 rounded-circle bg-opacity-50 d-flex shadow'>
                          <img src={Bolt} alt='standard star' fill='var(--bs-violet)' className='text-primary m-auto' width='17' height='17' stroke='0' />
                        </div>
                        <div className='d-flex justify-content-center align-items-center ms-4 text-medium-22 text-white'>Enhanced</div>
                      </div>
                    </div>
                    <p className='p-2 mb-0 text-regular-12 text-white'>With Enhanced disputes, DisputeLy will help you dispute with multiple credit reporting agencies such the direct creditors associated with your accounts, other bureaus such as LexisNexis, and many more destinations. The ultimate goal being; getting as many agents as possible investigating your disputed items. Instead of relying on the credit bureaus doing all of the communicating between other agencies, the enhanced approach sees a more direct method of attacking the negative aspects of your credit reports.</p>
                    <Button variant='light' className={`text-primary w-100 mx-auto d-block mt-3 fw-semibold fs-3 ${userCurrentInfo?.response?.current_plan === '2' ? '' : 'seesaw'} `} onClick={() => navigate(userCurrentInfo?.response?.current_plan === '2' ? '' : '/enhance-dispute')}>
                      {userCurrentInfo?.response?.current_plan === '2' ? 'You Are Enhanced!' : 'Upgrade Now!'}
                    </Button>
                  </Card.Body>
                </div>
              </Card>
            </Col>
          </Row>
          <div className='text-black mb-3'>Building Positive History</div>
          <CreditBuilder colSize={12} noWalkThrough={true} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default CreditAudit;
